"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var Toggle = _stylitas.styled.div(function (_ref) {
  var theme = _ref.theme,
      fontColor = _ref.fontColor;

  var _palette$fontColor;

  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border: none;\n    background-color: transparent;\n    color: ", ";\n    margin-right: 0;\n\n    ", "\n  "])), ((_palette$fontColor = _styleUtilities.palette[fontColor]) == null ? void 0 : _palette$fontColor.call(_styleUtilities.palette, theme)) || _styleUtilities.palette.fontNeutral90(theme), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      display: none;\n    "]))));
});

exports.Toggle = Toggle;